<template>
  <b-modal
    ref="provinceModal"
    size="xs"
    centered
    modal-class="province-modal"
    @hide="cleanData"
  >
    <div slot="modal-title">
      {{ actionTitle }} <span style="text-transform: lowercase">{{ $tc('configuration.sections.provinces', 1) }}</span>
    </div>
    <b-row class="pt-2 pb-3 px-3">
      <b-col cols="12">
        <div class="form-label">
          <label>{{ $tc('configuration.sections.countries', 1) }}</label>
        </div>
        <vt-combo-select
          ref="countrySelect"
          v-model="country"
          track-by="id"
          label="name"
          ajax-search
          :internal-search="false"
          :option-loader="getCountries"
          @close="handleCloseCountrySelect"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $t('configuration.grid.externalCode') }}</label>
        </div>
        <vt-input
          ref="code"
          v-model="internalProvince.code"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3"
      >
        <div class="form-label">
          <label>{{ $tc('configuration.sections.provinces', 1) }}</label>
        </div>
        <vt-input
          v-model="internalProvince.name"
          class="form-control-sm"
        />
      </b-col>
      <b-col
        cols="12"
        class="mt-3 d-flex justify-content-end"
      >
        <div class="switch-btn mt-1 p-0 d-flex align-items-center">
          <span
            v-if="internalProvince.active"
            class="mr-2"
          >{{ $t('configuration.actions.active') }}</span>
          <span
            v-else
            class="mr-2"
          >{{ $t('configuration.actions.inactive') }}</span>
          <input
            id="toggle"
            v-model="internalProvince.active"
            type="checkbox"
            class="offscreen"
            aria-hidden="true"
          >
          <label
            for="toggle"
            class="switch mb-0"
          />
        </div>
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner px-2"
      style="width:100%;"
    >
      <div class="row">
        <div class="col-6 text-left">
          <b-button
            size="sm"
            variant="outline-secondary"
            data-dismiss="modal"
            @click="hide"
          >
            {{ $t('global.cancel') }}
          </b-button>
        </div>
        <div class="col-6 text-right">
          <b-button
            :disabled="!internalProvince.code || !internalProvince.name || !country"
            size="sm"
            class="btn--primary"
            @click="update"
          >
            <i
              class="fal fa-check mr-2"
              aria-hidden="true"
            />
            {{ actionTitle }}
          </b-button>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import { isEmpty } from 'lodash'
import CountryConfigurationServices from '@/api/resources/configuration/demography/country/CountryConfigurationServices'
import { GridUtils } from '@/shared/util/grid-utils'

export default {
    name: 'ProvinceModal',
    props: {
        actionTitle: String
    },
    data() {
        return {
            internalProvince: {},
            country: null
        }
    },
    methods: {
        show(selectedProvince) {
            this.cleanData()
            if (selectedProvince && !isEmpty(selectedProvince)) {
                this.internalProvince = {
                    active: selectedProvince.active,
                    code: selectedProvince.code,
                    countryId: selectedProvince.country.id,
                    id: selectedProvince.id,
                    name: selectedProvince.name
                }
                this.country = selectedProvince.country
            }
            this.$refs.provinceModal.show()
        },
        hide() {
            this.$refs.provinceModal.hide()
        },
        update() {
            this.internalProvince.countryId = this.country.id
            if (this.internalProvince.id) this.$emit('update', this.internalProvince)
            else this.$emit('create', this.internalProvince)
        },
        cleanData() {
            this.internalProvince = {
                active: true,
                code: '',
                name: ''
            }
            this.country = null
        },
        handleCloseCountrySelect() {
            this.$refs.countrySelect.clearInternalOptions()
        },
        async getCountries(query) {
            if (query) {
                const filterModel = {
                    'name': GridUtils.getTextFilterModel('contains', query),
                    'active': GridUtils.getSetFilterModel(['true'])
                }
                const paginator = await CountryConfigurationServices.paginator(filterModel)
                return paginator.content
            }
            return []
        }
    }
}
</script>
